module.exports = __webpack_public_path__ + "static/img/6.87ec214.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/6.png
// module id = YC8o
// module chunks = 0